import { Routes } from '@angular/router';

export const devtoolsRoutes: Routes = [
    { path: '', redirectTo: 'get-started', pathMatch: 'full' },
    { path: 'get-started', loadComponent: () => import('./devtools/get-started/get-started.page').then(mod => mod.DevtoolsGetStartedPage) },
    { path: 'icons', loadComponent: () => import('./devtools/icons/icons.page').then(mod => mod.DevtoolsIconsPage) },
    { path: 'ui-components',
      children: [
        { path: 'buttons', loadComponent: () => import('./devtools/ui-components/component-button/component-button.page').then(mod => mod.DevtoolsUiComponentButtonPage) },
        { path: 'slider', loadComponent: () => import('./devtools/ui-components/component-slider/component-slider.page').then(mod => mod.DevtoolsComponentSliderPage) },
      ]
    },
    { path: 'style-utilities', loadComponent: () => import('./devtools/style-utilities/style-utilities.page').then(mod => mod.DevtoolsStyleUtilitiesPage) },
];